import { Component, Input, OnInit } from '@angular/core';
import { SetoresService } from 'src/app/services/setores.service';

interface SetorType {
  id: number
  descricao: string
  checked: boolean
}

@Component({
  selector: 'app-totem-setores',
  templateUrl: './totem-setores.component.html',
  styleUrls: ['./totem-setores.component.scss']
})
export class TotemSetoresComponent implements OnInit {

  setores: SetorType[] = []
  @Input()
  totemId: number | undefined

  constructor(
    private setoresService: SetoresService
  ) { }

  ngOnInit(): void {
    this.setores.push({
      id: -1,
      descricao: 'Geral (agendamentos)',
      checked: false
    })

    this.setoresService.getSetores().subscribe((setoresBody) => {
      for (const i of setoresBody) {
        this.setores.push({
          id: i.id,
          descricao: i.descricao,
          checked: false
        })
      }

      this.setoresService.getSetoresByTotem(this.totemId!).subscribe((setoresAtivos) => {
        for (let i of this.setores) {
          const setor = setoresAtivos.setores.find((el: any) => el.setor_id === i.id)
          if (setor) i.checked = true
        }
      })
    })
  }

  onChangeCheckbox(setorId: number | string): void {
    if (this.setores.find((val) => val.id === setorId)!.checked) {
      this.setoresService.insertSetorInTotem(this.totemId || 0, setorId).subscribe()
    } else {
      this.setoresService.deleteSetorFromTotem(this.totemId || 0, setorId).subscribe()
    }
  }

}
